/* The shop script. Built by tools/build-assets.mjs from the review set; edit the review set, not this file. */
/* XGO shop: the three behaviours the product pages add to web.js, and nothing else.
   1. The light-mode demonstrator: three toggles tint the gallery's stage with a class on the product block (data-mode); one is on
      at a time, as the light shows one colour at a time. ?mode=3000 (or 4300, 5000) opens on a mode, for the renders.
   2. The buy bar: the phone bar with the price and Add to cart. It shows once the page has been scrolled and the page's own Add
      to cart is off screen, and it steps aside while the footer is on screen. Its button submits the page's own form.
   3. The owners' stack (round six): five owners' prints fanned in a stack, the front one's words beside it, a review at a time. */
(function () {
  var root = document.documentElement;
  if (!root || root.dataset.xgoShop) return;
  root.dataset.xgoShop = '1';

  /* ---------- the light-mode demonstrator ---------- */
  var modes = root.querySelector('[data-modes]'), host = root.querySelector('[data-mode-host]');
  if (modes && host) {
    var set = function (m) {
      host.setAttribute('data-mode', m);
      [].forEach.call(modes.querySelectorAll('[data-mode-to]'), function (b) {
        var on = b.getAttribute('data-mode-to') === m;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    modes.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-mode-to]') : null;
      if (b) set(b.getAttribute('data-mode-to'));
    });
    var want = new URLSearchParams(location.search).get('mode');
    if (want && modes.querySelector('[data-mode-to="' + want + '"]')) set(want);
  }

  /* ---------- the buy bar ---------- */
  var bar = root.querySelector('[data-buybar]'), buy = root.querySelector('[data-buy]'), foot = root.querySelector('.ti-ftr');
  if (bar && buy && 'IntersectionObserver' in window) {
    var buyOn = true, footOn = false, moved = false;
    var sync = function () {
      var on = moved && !buyOn && !footOn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target === buy) buyOn = e.isIntersecting;
        else footOn = e.isIntersecting;
      });
      sync();
    }, { threshold: 0 });
    io.observe(buy);
    if (foot) io.observe(foot);
    window.addEventListener('scroll', function () { if (!moved) { moved = true; sync(); } }, { passive: true });
  }

  /* ---------- the owners' stack (round six, 25 September) ----------
     Five prints fanned in a stack and the front print's words beside them. While it is on screen it turns a review at a time:
     the front print lifts away and returns at the back as the next comes forward, and the words cross-fade. A review is held
     longer the more it has to say, 5 to 8 seconds; the first turns after 4, so the stack is seen to move. The first time it is on screen
     the prints deal out from one pile into the fan, and the bar under the words fills over each hold from then. The pointer or the keyboard holds it; the bars under the words choose one.
     Under reduced motion it stays still and the bars still choose. Online, it asks Judge.me's public feed (the one the store's
     widget reads) for the product's reviews with a photograph, and one it does not show yet takes the front; the port reads the
     same feed. */
  var startStack = function (stack) {
    var printsBox = stack.querySelector('.ti-stack__prints'), wordsBox = stack.querySelector('.ti-stack__words'), navBox = stack.querySelector('.ti-stack__nav');
    var prints = [].slice.call(stack.querySelectorAll('.ti-stack__p'));
    var says = [].slice.call(stack.querySelectorAll('.ti-stack__w'));
    var dots = [].slice.call(stack.querySelectorAll('[data-stack-to]'));
    var still = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    var order = prints.map(function (p, i) { return i; });   // order[0] is the review in front
    var timer = null, onScreen = false, held = false, first = true;
    var holdFor = function (i) {
      var n = (says[i].querySelector('blockquote') || says[i]).textContent.trim().split(/\s+/).length;
      return Math.max(5000, Math.min(8000, 2800 + n * 110));
    };
    var paint = function () {
      order.forEach(function (i, pos) { prints[i].setAttribute('data-pos', pos); });
      var f = order[0];
      says.forEach(function (el, i) { var on = i === f; el.classList.toggle('is-on', on); if (on) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true'); });
      dots.forEach(function (d) { var on = +d.getAttribute('data-stack-to') === f; d.classList.toggle('is-on', on); if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      stack.style.setProperty('--hold', holdFor(f) + 'ms');
    };
    var schedule = function () {
      clearTimeout(timer);
      [].forEach.call(navBox.querySelectorAll('.ti-stack__dot'), function (d) { d.classList.remove('is-run'); });
      if (still || held || !onScreen) return;
      var ms = first ? Math.min(4000, holdFor(order[0])) : holdFor(order[0]);   // the first turn comes soon, so the stack is seen to move
      first = false;
      stack.style.setProperty('--hold', ms + 'ms');
      var on = navBox.querySelector('.ti-stack__dot.is-on');
      if (on) { void on.offsetWidth; on.classList.add('is-run'); }   // the bar fills over the hold it stands for, from now
      timer = setTimeout(turn, ms);
    };
    var turn = function () {
      var front = prints[order[0]];
      front.classList.add('is-lift');
      setTimeout(function () {
        order.push(order.shift());
        front.classList.remove('is-lift');   // back in the stack, at the back
        paint();
        schedule();
      }, 600);
    };
    var go = function (i) {
      clearTimeout(timer);
      if (order.indexOf(i) < 0) return;
      while (order[0] !== i) order.push(order.shift());
      paint();
      schedule();
    };
    var wire = function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-stack-to')); }); };
    dots.forEach(wire);
    var hold = function (v) { held = v; stack.classList.toggle('is-held', v); if (v) clearTimeout(timer); else schedule(); };
    stack.addEventListener('mouseenter', function () { hold(true); });
    stack.addEventListener('mouseleave', function () { hold(false); });
    stack.addEventListener('focusin', function () { hold(true); });
    stack.addEventListener('focusout', function (e) { if (!stack.contains(e.relatedTarget)) hold(false); });
    if (still) stack.classList.add('is-still', 'is-dealt');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { onScreen = e.isIntersecting; if (onScreen) { stack.classList.add('is-dealt'); paint(); schedule(); } else clearTimeout(timer); });   // the fan deals out the first time it is seen
      }, { threshold: 0.35 }).observe(stack);
    } else { onScreen = true; stack.classList.add('is-dealt'); schedule(); }
    paint();

    /* a new review with a photograph, from the feed: a print and its words at the front, the back one leaving so five stay */
    var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.6l2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8z"/></svg>';
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
    var starsOf = function (n) { var s = el('span', 'ti-stars'); s.setAttribute('role', 'img'); s.setAttribute('aria-label', 'Rated ' + n + ' out of 5'); s.innerHTML = new Array(n + 1).join(STAR); return s; };
    var addReview = function (r) {
      var pic = r.querySelector('.jdgm-rev__pic-link:not(.jdgm-rev__product-picture)');
      var src = pic && pic.getAttribute('href');
      if (!src || src.indexOf('https://review-images.judgeme.com/') !== 0) return;
      var who = (r.querySelector('.jdgm-rev__author') || {}).textContent || 'Owner';
      var score = +((r.querySelector('[data-score]') || { getAttribute: function () { return 5; } }).getAttribute('data-score')) || 5;
      var title = ((r.querySelector('.jdgm-rev__title') || {}).textContent || '').trim();
      var body = ((r.querySelector('.jdgm-rev__body') || {}).textContent || '').trim();
      var stamp = (r.querySelector('.jdgm-rev__timestamp') || { getAttribute: function () { return ''; } }).getAttribute('data-content') || '';
      var m = stamp.match(/(\d{4})-(\d\d)-(\d\d)/), date = m ? (+m[3]) + ' ' + MONTHS[+m[2] - 1] + ' ' + m[1] : '';
      var light = (r.getAttribute('data-product-title') || '').replace(/ Tri-Colour Dimmable/, '').replace(/ Light$/, '');
      var i = prints.length;
      var fig = el('figure', 'ti-pin__print ti-stack__p');
      fig.setAttribute('data-i', i); fig.style.setProperty('--rot', '-2deg');
      var well = el('div', 'ti-pin__well'), img = el('img');
      img.src = src.replace(/width=\d+/, 'width=800'); img.alt = 'An owner’s photograph of the light, fitted'; img.decoding = 'async';
      well.appendChild(img); fig.appendChild(well);
      var cap = el('figcaption'), rate = el('span', 'ti-pin__rating');
      rate.appendChild(starsOf(score)); rate.appendChild(el('span', 'ti-pin__source', 'Judge.me review'));
      cap.appendChild(rate); cap.appendChild(el('span', 'ti-pin__title', who.split(' ')[0].replace(/\.$/, ''))); cap.appendChild(el('span', 'ti-pin__spec', light));
      fig.appendChild(cap);
      var art = el('article', 'ti-rev__c ti-stack__w');
      art.setAttribute('data-i', i); art.setAttribute('data-jdgm', 'review'); art.setAttribute('data-review-id', r.getAttribute('data-review-id') || '');
      art.appendChild(starsOf(score));
      var q = el('blockquote'); if (title) q.appendChild(el('p', 'ti-rev__t', title)); q.appendChild(document.createTextNode(body)); art.appendChild(q);
      var w = el('div', 'ti-rev__w'), line = el('span'); line.appendChild(el('b', null, who));
      line.appendChild(document.createTextNode((r.getAttribute('data-verified-buyer') === 'true' ? 'Verified buyer' : 'Judge.me review') + (date ? ' · ' + date : '') + (light ? ' · ' + light : '')));
      w.appendChild(line); art.appendChild(w);
      var dot = el('button', 'ti-stack__dot'); dot.type = 'button'; dot.setAttribute('data-stack-to', i); dot.setAttribute('aria-label', who + '’s review');
      printsBox.appendChild(fig); wordsBox.appendChild(art); navBox.insertBefore(dot, navBox.firstChild); wire(dot);
      prints.push(fig); says.push(art); dots.push(dot);
      order.unshift(i);
      if (order.length > 5) {   // the one at the back leaves
        var out = order.pop();
        prints[out].remove(); says[out].remove();
        dots.filter(function (d) { return +d.getAttribute('data-stack-to') === out; }).forEach(function (d) { d.remove(); });
      }
    };
    var pid = stack.getAttribute('data-jdgm-photos');
    if (pid && window.fetch && window.DOMParser) {
      fetch('https://api.judge.me/reviews/reviews_for_widget?url=teralume-industries.myshopify.com&shop_domain=teralume-industries.myshopify.com&platform=shopify&page=1&per_page=50&product_id=' + encodeURIComponent(pid))
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (d) {
          if (!d || !d.html) return;
          var doc = new DOMParser().parseFromString(d.html, 'text/html'), have = {};
          says.forEach(function (s) { have[s.getAttribute('data-review-id')] = 1; });
          var fresh = [].slice.call(doc.querySelectorAll('.jdgm-rev[data-review-id]')).filter(function (r) { return !have[r.getAttribute('data-review-id')] && r.querySelector('.jdgm-rev__pic-link'); });
          if (!fresh.length) return;
          fresh.slice(0, 5).reverse().forEach(addReview);
          stack.setAttribute('data-jdgm-fresh', fresh.length);
          paint(); schedule();
        })
        .catch(function () { /* offline, or the feed moved: the stack keeps the reviews it was built with */ });
    }
  };
  var stack = root.querySelector('[data-stack]');
  if (stack && stack.querySelector('.ti-stack__p')) startStack(stack);
  else window.tiStack = startStack;
})();
